import React, { useEffect } from 'react'
import Banner from '../Components/banner/Banner';
import BannerData from "../models/BannersData";
import TreatmentsData from '../models/TreatmentsData';
import BreadcrumbsComponent from '../Components/common/BreadcrumbsComponent';
import { useParams } from 'react-router';
import TreatmentContent from '../Components/contents/TreatmentContent';
import TreatmentInclusionsGrid from '../Components/grid/TreatmentInclusionsGrid';
import TreatmentsSlider from '../Components/slider/TreatmentsSlider';

const TreatmentDetailsPage = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const { TreatmentName } = useParams();

    const BreadCrumbsPath = [
        {
            id: 1,
            pathName: "Treatments",
            pathLink: "/Treatments",
        },
        {
            id: 2,
            pathName: TreatmentName,
            pathLink: "",
        },
    ];

    return (
        <>
            {BannerData.filter((item) => item.title === "Treatment").map((item) => (
                <Banner key={item.id} bannerDetails={item} />
            ))}

            <BreadcrumbsComponent fullWidth BreadCrumbsPath={BreadCrumbsPath} />

            {TreatmentsData.filter((treatment) => treatment.title === TreatmentName).map((treatment) => (

                <React.Fragment key={treatment.id}>
                    <TreatmentContent key={treatment.id} treatmentData={treatment} />

                    <TreatmentInclusionsGrid TreatmentInclusions={treatment.inclusions} />

                    <TreatmentsSlider Category={treatment.categoryName} />
                </React.Fragment>

            ))}
        </>
    )
}

export default TreatmentDetailsPage